import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useCookies } from 'react-cookie';

import { Privacy } from './components/Privacy';
import CookieIcon from '@static/images/icons/cookie-bite.svg';

import * as styles from './Cookies.module.scss';

export const Cookies: React.FC = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [cookies, setCookie] = useCookies<string>(['cookieBanner']);
	const popupRef = useRef<HTMLDivElement>(null);
	const privacyButtonRef = useRef<HTMLButtonElement>(null);

	const body =
		typeof window !== `undefined` ? document.querySelector('body') : null;

	useEffect(() => {
		document.addEventListener('click', handleClickAway);

		return () => document.removeEventListener('click', handleClickAway);
	}, [isOpen]);

	const handlePrivacyPopup = () => {
		setIsOpen(!isOpen);
		body.style.overflow = !isOpen ? 'hidden' : 'auto';
	};

	const handleAcceptCookies = () => {
		setCookie('cookieBanner', true, { path: '/' });
	};

	const handleClickAway = (e: MouseEvent) => {
		if (
			isOpen &&
			!popupRef.current?.contains(e.target as Node) &&
			!privacyButtonRef.current?.contains(e.target as Node)
		) {
			setIsOpen(false);
			body.style.overflow = 'auto';
		}
	};

	return (
		<>
			{!cookies.cookieBanner ? (
				<>
					<div className={classNames(styles.cookies, styles.active)}>
						<img
							className={styles.cookieIcon}
							alt="Cookie icon"
							src={CookieIcon}
						/>
						<p className={styles.cookieDescription}>
							Wir verwenden Cookies, um die Nutzung und Präferenzen zu
							verfolgen.
						</p>
						<div className={styles.cookieButtons}>
							<button
								className={classNames(styles.agree, styles.cookieBtn)}
								onClick={handleAcceptCookies}
							>
								ICH VERSTEHE
							</button>
							<button
								ref={privacyButtonRef}
								className={classNames(styles.privacy, styles.cookieBtn)}
								onClick={handlePrivacyPopup}
							>
								DATENSCHUTZPOLITIK
							</button>
						</div>
					</div>
					{isOpen && (
						<Privacy handleClosePopup={handlePrivacyPopup} ref={popupRef} />
					)}
				</>
			) : null}
		</>
	);
};

